/* jquery slider */
$(document).ready(function(){
    $('.home-testimonials-carrousel').slick({
        slidesToShow: 2,
        slidesToScroll: 2,
        autoplay: false,
        autoplaySpeed: 1500,
        arrows: false,
          // prevArrow: '<img src="https://cdn.shopify.com/s/files/1/0360/2877/6583/files/Arrowssvg-06.svg?v=1646332238" alt="previous" class="slick-prev-quotes">',
          // nextArrow: '<img src="https://cdn.shopify.com/s/files/1/0360/2877/6583/files/Arrowssvg-05.svg?v=1646332238" alt="next" class="slick-next-quotes">',
        dots: true,
        pauseOnHover: false,
            responsive: [
            {
            breakpoint: 1023,
            settings: {
                arrows: false,
                dots:true,
                slidesToShow: 1,
            }
            }
        ]
        });
    
  });